import request from '@/utils/request'; // 服务名：ecargopolicy
// 产品配置维护数据

export function product_queryProduct(data) {
  return request({
    url: '/ecargopolicy/productConfiguration/queryProduct',
    method: 'post',
    data: data
  });
}
export function product_queryPage(data) {
  return request({
    url: '/ecargopolicy/productConfiguration/queryPage',
    method: 'post',
    data: data
  });
} //  产品删除

export function deleteProduct(data) {
  return request({
    url: '/ecargopolicy/productConfiguration/deleteProduct',
    method: 'get',
    params: data
  });
} //  产品保存

export function saveProduct(data) {
  return request({
    url: '/ecargopolicy/productConfiguration/saveProduct',
    method: 'post',
    data: data
  });
} //  产品编辑保存

export function saveEditProduct(data) {
  return request({
    url: '/ecargopolicy/productConfiguration/saveEditProduct',
    method: 'post',
    data: data
  });
} //  获取所有配置的产品

export function getAllProductConfData() {
  return request({
    url: '/ecargopolicy/productConfiguration/queryAll',
    method: 'get'
  });
} // 理赔代理点维护数据

export function agentClaim_queryPage(data) {
  return request({
    url: '/ecargopolicy/agentClaim/queryPage',
    method: 'post',
    data: data
  });
} //  理赔代理点删除

export function deleteBcAgentClaim(data) {
  return request({
    url: '/ecargopolicy/agentClaim/deleteBcAgentClaim',
    method: 'get',
    params: data
  });
} //  理赔代理点保存

export function saveBcAgentClaim(data) {
  return request({
    url: '/ecargopolicy/agentClaim/saveBcAgentClaim',
    method: 'post',
    data: data
  });
} // 理赔代理点导入

export function agentClaim_import(data) {
  return request({
    url: '/ecargopolicy/agentClaim/import',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  });
} // 高风险地区维护数据

export function highArea_queryPage(data) {
  return request({
    url: '/ecargopolicy/highArea/queryPage',
    method: 'post',
    data: data
  });
} // 产品条款责任导入

export function clause_queryPage(data) {
  return request({
    url: '/ecargopolicy/clause/queryPage',
    method: 'post',
    data: data
  });
} // 汇率导入---获取币种

export function exchange(data) {
  return request({
    url: '/ecargopolicy/exchange/queryAllCurrency',
    method: 'get',
    params: data
  });
} // 汇率导入---查询列表

export function exchange_queryPage(data) {
  return request({
    url: '/ecargopolicy/exchange/queryPage',
    method: 'post',
    data: data
  });
} // 特约查询

export function engage_queryPage(data) {
  return request({
    url: '/ecargopolicy/engage/queryPage',
    method: 'post',
    data: data
  });
} // 机构数据维护

export function company_queryPage(data) {
  return request({
    url: '/ecargopolicy/company/queryPage',
    method: 'post',
    data: data
  });
} // 机构数据新增/修改

export function saveCompany(data) {
  return request({
    url: '/ecargopolicy/company/saveCompany',
    method: 'post',
    data: data
  });
} // 机构数据删除

export function deleteCompany(data) {
  return request({
    url: '/ecargopolicy/company/deleteCompany',
    method: 'get',
    params: data
  });
} // 机构银行账户维护

export function companyBank_queryPage(data) {
  return request({
    url: '/ecargopolicy/companyBank/queryPage',
    method: 'post',
    data: data
  });
} // 机构银行账户维护新增/修改

export function saveCompanyBank(data) {
  return request({
    url: '/ecargopolicy/companyBank/saveCompanyBank',
    method: 'post',
    data: data
  });
} // 机构银行账户维护删除

export function deleteCompanyBank(data) {
  return request({
    url: '/ecargopolicy/companyBank/deleteCompanyBank',
    method: 'get',
    params: data
  });
} // 限额免赔

export function limit_queryPage(data) {
  return request({
    url: '/ecargopolicy/limit/queryPage',
    method: 'post',
    data: data
  });
} // 限额免赔新增 / 修改

export function saveLimit(data) {
  return request({
    url: '/ecargopolicy/limit/saveLimit',
    method: 'post',
    data: data
  });
} // 限额免赔删除

export function deleteLimit(data) {
  return request({
    url: '/ecargopolicy/limit/deleteLimit',
    method: 'get',
    params: data
  });
} // 获取文件地址

export function getExcelPath(data) {
  return request({
    url: '/ecargopolicy/proposalDownload/getExcelPath',
    method: 'post',
    data: data
  });
} // 获取文件

export function download(data) {
  return request({
    url: '/commondictionary/file/download',
    method: 'get',
    params: data,
    responseType: 'arraybuffer'
  });
} // 获取文件

export function download1(data) {
  return request({
    url: '/ecargocredit/creditCommon/download',
    method: 'get',
    params: data,
    responseType: 'arraybuffer'
  });
} // 机构银行导入

export function companyBank_import(data) {
  return request({
    url: '/ecargopolicy/companyBank/import',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  });
} // 条款导入

export function clause_import(data) {
  return request({
    url: '/ecargopolicy/clause/import',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  });
} // 条款新增/修改

export function saveClause(data) {
  return request({
    url: '/ecargopolicy/clause/saveClause',
    method: 'post',
    data: data
  });
} // 条款删除

export function deleteClause(data) {
  return request({
    url: '/ecargopolicy/clause/deleteClause',
    method: 'get',
    params: data
  });
} // 高风险地区导入

export function highArea_import(data) {
  return request({
    url: '/ecargopolicy/highArea/import',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  });
} // 高风险地区新增/修改

export function saveHighArea(data) {
  return request({
    url: '/ecargopolicy/highArea/saveHighArea',
    method: 'post',
    data: data
  });
} // 高风险地区删除

export function deleteHighArea(data) {
  return request({
    url: '/ecargopolicy/highArea/deleteHighArea',
    method: 'get',
    params: data
  });
} // 限额免赔导入

export function limit_import(data) {
  return request({
    url: '/ecargopolicy/limit/import',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  });
} // 分支机构导入

export function company_import(data) {
  return request({
    url: '/ecargopolicy/company/import',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  });
} // 汇率导入

export function exchange_import(data) {
  return request({
    url: '/ecargopolicy/exchange/import',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  });
} // 汇率新增 / 修改

export function saveExchange(data) {
  return request({
    url: '/ecargopolicy/exchange/saveExchange',
    method: 'post',
    data: data
  });
} // 汇率删除

export function deleteExchange(data) {
  return request({
    url: '/ecargopolicy/exchange/deleteExchange',
    method: 'get',
    params: data
  });
} //特约导入

export function engage_import(data) {
  return request({
    url: '/ecargopolicy/engage/import',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  });
} //特约新增/修改

export function saveEngage(data) {
  return request({
    url: '/ecargopolicy/engage/saveEngage',
    method: 'post',
    data: data
  });
} //特约删除

export function deleteEngage(data) {
  return request({
    url: '/ecargopolicy/engage/deleteEngage',
    method: 'get',
    params: data
  });
} // 自定义标的管理

export function mark_query(data) {
  return request({
    url: '/ecargopolicy/item/queryPage',
    method: 'post',
    data: data
  });
} // 自定义标的删除

export function deleteItem(data) {
  return request({
    url: '/ecargopolicy/item/deleteItem',
    method: 'get',
    params: data
  });
} // / 自定义标的导入 item/import

export function item_import(data) {
  return request({
    url: '/ecargopolicy/item/import',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  });
} // 自定义标的修改

export function saveItem(data) {
  return request({
    url: '/ecargopolicy/item/saveItem',
    method: 'post',
    data: data
  });
} // 自定义标的有效或无效

export function updateValidStatus(data) {
  return request({
    url: '/ecargopolicy/item/updateValidStatus',
    method: 'post',
    data: data
  });
} // 自定义标的条件查询所有数据

export function getSelfItemList(data) {
  return request({
    url: '/ecargopolicy/item/getSelfItemList',
    method: 'post',
    data: data
  });
} // -----------------------------------------------自定义运输地区

export function customRegion_queryPage(data) {
  return request({
    url: '/ecargopolicy/customRegion/queryPage',
    method: 'post',
    data: data
  });
} // 新增 / 修改

export function saveCustomRegion(data) {
  return request({
    url: '/ecargopolicy/customRegion/save',
    method: 'post',
    data: data
  });
} // 删除

export function deleteCustomRegion(data) {
  return request({
    url: '/ecargopolicy/customRegion/delete',
    method: 'get',
    params: data
  });
}
export function customRegion_queryAll(data) {
  return request({
    url: '/ecargopolicy/customRegion/queryAll',
    method: 'get',
    params: data
  });
} // ------------------------------------------------业务员
// 业务员分页查询接口

export function getSalesInfo(data) {
  return request({
    url: '/ecargopolicy/BcSales/queryPage',
    method: 'post',
    data: data
  });
} // 删除业务员

export function deleteSales(data) {
  return request({
    url: '/ecargopolicy/BcSales/delete',
    method: 'get',
    params: data
  });
} // 添加/编辑

export function saveSales(data) {
  return request({
    url: '/ecargopolicy/BcSales/save',
    method: 'post',
    data: data
  });
} // 业务员禁用

export function prohibitSales(data) {
  return request({
    url: '/ecargopolicy/BcSales/prohibit',
    method: 'get',
    params: data
  });
} // 业务员查看

export function lookSales(data) {
  return request({
    url: '/ecargopolicy/BcSales/look',
    method: 'get',
    params: data
  });
} // 业务员批量导入

export function importSales(data) {
  return request({
    url: '/ecargopolicy/BcSales/import',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  });
} // ----------------------------------------------------中介机构
// 中介机构分页查询入参

export function queryPageIntermediary(data) {
  return request({
    url: '/ecargopolicy/BcIntermediary/queryPage',
    method: 'post',
    data: data
  });
} // 中介机构查看

export function lookIntermediary(data) {
  return request({
    url: '/ecargopolicy/BcIntermediary/look',
    method: 'get',
    params: data
  });
} //  删除中介机构

export function deleteIntermediary(data) {
  return request({
    url: '/ecargopolicy/BcIntermediary/delete',
    method: 'get',
    params: data
  });
} // 中介机构 单条新增/编辑按钮

export function saveIntermediary(data) {
  return request({
    url: '/ecargopolicy/BcIntermediary/save',
    method: 'post',
    data: data
  });
} // 中介机构 禁用

export function prohibitIntermediary(data) {
  return request({
    url: '/ecargopolicy/BcIntermediary/prohibit',
    method: 'get',
    params: data
  });
} // 中介机构批量导入

export function importIntermediary(data) {
  return request({
    url: '/ecargopolicy/BcIntermediary/import',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  });
} //--------------------------------基本数据页面提供接口
// 归属机构查询所有

export function findAllCompany(data) {
  return request({
    url: '/ecargopolicy/company/findAll',
    method: 'get',
    params: data
  });
} // 保险公司基础数据单条删除

export function deleteBasics(data) {
  return request({
    url: '/ecargopolicy/BcInsuranceCode/delete',
    method: 'get',
    params: data
  });
} // 保险公司基础数据批量导入

export function importBasics(data) {
  return request({
    url: '/ecargopolicy/BcInsuranceCode/import',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  });
} // 保险公司基础数据单条禁用

export function prohibitBasics(data) {
  return request({
    url: '/ecargopolicy/BcInsuranceCode/prohibit',
    method: 'get',
    params: data
  });
} // 保险公司基础数据单条查看

export function lookBasics(data) {
  return request({
    url: '/ecargopolicy/BcInsuranceCode/look',
    method: 'get',
    params: data
  });
} // 保险公司基础数据分页查询

export function queryPageBasics(data) {
  return request({
    url: '/ecargopolicy/BcInsuranceCode/queryPage',
    method: 'post',
    data: data
  });
} // 保险公司基础数据单条新增/编辑

export function saveBasics(data) {
  return request({
    url: '/ecargopolicy/BcInsuranceCode/save',
    method: 'post',
    data: data
  });
}